import { ReactNode, useState } from 'react';

import { CommandPalette } from './CommandPalette';
import { Header } from './Header';
import { MobileDrawer } from './MobileDrawer';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="app-shell">
      <Sidebar />
      <MobileDrawer
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />
      <div className="lg:pl-[var(--sidebar-width)]">
        <Header
          onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          isMenuOpen={isMobileMenuOpen}
        />
        <main className="app-content">
          <div className="app-content-inner">{children}</div>
        </main>
      </div>
      <CommandPalette />
    </div>
  );
}
